import React from 'react';
import { Skeleton } from '@brokerbay/elements-web';

const TitleSkeleton = () => (
    <>
      <Skeleton
        title={{
          style: {
            height: 16,
            width: 200,
            margin: '0px auto 15px auto',
          },
        }}
        paragraph={false}
        round
      />
      <Skeleton
        title={{ style: { height: 45, width: '100%' } }}
        paragraph={false}
      />
    </>
  );

export default TitleSkeleton;
